import { useRef } from "react";
import { Helmet } from "react-helmet";
import "../Terms/styled.scss";
import "../../../home.scss";

const RewardTermsHeader = () => {
  return (
    <div className="section terms_head" style={{}}>
      <div className="content_container">
        <div
          className="content terms_head"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="terms_head_left">
            <h1>Brandclub Reward Terms and Conditions</h1>
          </div>
        </div>
      </div>
    </div>
  );
};
const RewardTermsContent = () => {
  return (
    <div className="section terms" style={{}}>
      <div className="content_container" style={{}}>
        <div className="content terms">
          <div className="terms_body">
            <div className="terms_sec">
              <div className="title">
                <div className="text">Overview</div>
              </div>
              <div className="content">
                <p>
                  Last updated: October 18. 2024
                  <br />
                  <br />
                  These Brandclub Rewards Program Terms (“
                  <strong>Rewards Terms</strong>”) describe the terms and
                  conditions that apply to your participation (“
                  <strong>you</strong>” or “<strong>Member</strong>”) in
                  Brandclub’s Rewards Program (“<strong>Rewards Program</strong>
                  ”) and are between you and Brandclub, LLC ( “
                  <strong>we</strong>” or “<strong>us</strong>” or “
                  <strong>Brandclub</strong>”). By participating in the Rewards
                  Program, you agree to these Rewards Terms and the Brandclub
                  Terms of Service (together, the “<strong>Terms</strong>”)
                  which govern your use of Brandclub’s website and Services,
                  including Services hosted for third-party Brands
                  (collectively, the “<strong>Service</strong>”). All
                  capitalized but undefined terms in these Rewards Terms have
                  the meanings ascribed to them in the Terms of Service, and
                  these Rewards Terms are incorporated by reference into the
                  Terms of Service.
                  <br />
                  <br />
                  <strong>
                    BY PARTICIPATING IN THE REWARDS PROGRAM, OR BY AGREEING TO
                    THE BRANDCLUB TERMS OF SERVICE
                  </strong>
                  , YOU AGREE THAT YOU HAVE READ AND UNDERSTOOD, AND, AS A
                  CONDITION TO YOUR PARTICIPATION IN THE REWARDS PROGRAM, YOU
                  AGREE TO BE BOUND BY, THESE REWARDS TERMS.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Arbitration Notice</div>
              </div>
              <div className="content">
                <p>
                  <strong>Arbitration Notice</strong>: These Rewards Terms, via
                  the Brandclub Terms of Service, contain provisions that govern
                  how claims between you and Brandclub will be resolved (see the
                  Brandclub Terms of Service for more details). Except for
                  certain kinds of disputes, YOU AGREE THAT DISPUTES ARISING
                  UNDER THESE REWARDS TERMS WILL BE RESOLVED BY BINDING,
                  INDIVIDUAL ARBITRATION AND THAT YOU AND BRANDCLUB ARE EACH
                  WAIVING THE RIGHT TO TRIAL BY JURY OR TO PARTICIPATE IN ANY
                  CLASS ACTION OR REPRESENTATIVE PROCEEDING.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Program Description</div>
              </div>
              <div className="content">
                <p>
                  <strong>1.1</strong> Brandclub has established a Rewards
                  Program pursuant to which Brandclub and participating Brands
                  may offer rewards to Members (“<strong>Rewards</strong>”) in
                  connection with qualifying use of the Service and certain
                  Brand purchases made via the Service (such purchases, the “
                  <strong>Brandclub Purchases</strong>”) by such Members, as
                  further described in these Rewards Terms.
                  <br />
                  <br />
                  <strong>1.2</strong> Rewards may be unlocked and redeemable
                  for cash as expressly described in these Rewards Terms. Locked
                  Rewards and Unlocked Rewards are subject to change in
                  Brandclub’s sole discretion.
                  <br />
                  <br />
                  <strong>1.3</strong> The Rewards Program is void where
                  prohibited.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Eligibility</div>
              </div>
              <div className="content">
                <p>
                  <strong>2.1</strong> You are eligible to participate in the
                  Rewards Program as a Member if you: (a) are at least 18 years
                  old; (b) have a valid customer account on the Service; and (c)
                  are not a current or former employee, contractor, affiliate,
                  or partner of Brandclub (or any of their immediate families
                  and household members).
                  <br />
                  <br />
                  <strong>2.2</strong> You represent and warrant to Brandclub
                  that (a) you are eligible to participate in the Rewards
                  Program; (b) you have not previously been suspended or banned
                  from participating in the Rewards Program; and (c) your
                  participation in the Rewards Program is in compliance with all
                  applicable laws and regulations.
                  <br />
                  <br />
                  <strong>2.3</strong> Brandclub reserves the right to deny,
                  reject, or revoke your participation in the Rewards Program
                  for any reason or no reason, including because you do not meet
                  the requirements to participate in this Rewards Program or
                  Brandclub, in its sole discretion, believes you have violated
                  the Terms.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">How it works</div>
              </div>
              <div className="content">
                <p>
                  <strong>3.1</strong> To become a Member, you must enroll for a
                  Brandclub account on the Service.
                  <br />
                  <br />
                  <strong>3.2</strong> You may view information about your
                  activity in the Rewards Program by visiting your Brandclub
                  account (your “<strong>Member Account</strong>”), which may be
                  accessed through the Service. You may only have one Member
                  Account per person. Your Member Account and any associated
                  Rewards are personal to you and cannot be combined with any
                  other Member Account or otherwise transferred or shared with
                  another Member Account for any reason, including inheritance
                  or divorce. You must not share your Member Account credentials
                  or give access to your Member Account to others. You are
                  solely responsible for safeguarding your Member Account access
                  information, including your Member Account credentials, or any
                  other information used by Brandclub to authenticate you.
                  Brandclub is not responsible for any unauthorized or
                  fraudulent access to or use of your Member Account. If you
                  believe anyone has accessed your Member Account, you agree to
                  report any such unauthorized access or use to Brandclub help
                  services as quickly as possible.
                  <br />
                  <br />
                  <strong>3.3</strong> Users may be blocked from creating a new
                  Member Account in Brandclub’s sole discretion if they use a
                  phone number or email address associated with an existing
                  Member Account, or show other signs of being an existing
                  Brandclub Member (e.g., if they have the same IP and/or device
                  address).
                  <br />
                  <br />
                  <strong>3.4</strong> Brandclub reserves the right to review
                  and investigate all Rewards Program activities. If at any time
                  Brandclub suspects or determines, in its sole discretion, that
                  you have not complied with its Terms or have otherwise abused
                  the spirit or Terms of this Rewards Program, Brandclub may,
                  immediately and without notice, terminate or suspend your
                  participation in the Rewards Program, void your Rewards, and
                  refuse to redeem any Rewards.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Rewards</div>
              </div>
              <div className="content">
                <p>
                  <strong>4</strong>. A Member may accrue Rewards by engaging
                  with specific Brands on the Service and participating in the
                  Brands’ various Rewards programs. Once unlocked, the Rewards
                  earned from each Brand will accrue as cash in the Member
                  Account and may be cashed out at any time subject to any
                  limitations described herein. While Rewards initiatives may
                  vary by Brand and change over time, the following Brandclub
                  Purchases and other activities may allow Members to earn
                  Rewards (subject to any specific instructions provided by the
                  Service or Brand):
                  <br />
                  <br />
                  <strong>Join a Brand’s Club</strong>: A Member may receive a
                  Reward for joining a specific Brand’s club. The Reward will be
                  issued in a locked state and may be unlocked for cash
                  redemption when a Member earns another Reward from the same
                  participating Brand.
                  <br />
                  <br />
                  <strong>
                    Purchase a Brand’s Products from an Approved Retailer
                  </strong>
                  : A Member may receive a Reward by purchasing an eligible
                  product. The Reward will be issued in a locked state and may
                  be unlocked for cash redemption when a Member earns another
                  Reward from the same participating Brand by purchasing another
                  eligible product from the participating Brand. All purchases
                  are deemed verified after the transaction and delivery of the
                  product have been confirmed by Brandclub in its sole
                  discretion.
                  <br />
                  <br />
                  <strong>
                    Recommend a Brand’s Product on One of Member’s Social Media
                    Accounts, by Email, or by Text Message
                  </strong>
                  : A Member may receive a Reward when another Brandclub user
                  clicks on the affiliate link (from text, email, or social
                  channel) and purchases the exact product in the link. The
                  transaction and delivery of the product must be verified by
                  Brandclub in its sole discretion. The Member that shared the
                  product link will receive an unlocked Reward from the
                  participating Brand. The Reward may be unlocked for cash
                  redemption when a Member earns another Reward from the same
                  participating Brand.
                  <br />
                  <br />
                  <strong>
                    Take a Survey that is Posted on the Service by a Brand
                  </strong>
                  : A Member may receive a cash Reward for completing a survey
                  when enrolled in a Brand’s club when the Brand is offering
                  this specific Reward. Following the completion of the survey,
                  the Reward will be issued in a locked state and may be
                  unlocked for cash redemption when a Member earns another
                  Reward from the same participating Brand by purchasing another
                  eligible product from the participating Brand. All purchases
                  are deemed verified after the transaction and delivery of the
                  product have been confirmed by Brandclub in its sole
                  discretion.
                  <br />
                  <br />
                  <strong>Integrating a Retailer into Brandclub</strong>: A
                  Member may receive a Reward by integrating a new retailer into
                  Brandclub. The member’s retailer account must be a valid
                  account as determined in Brandclub’s sole discretion. The
                  retailer account will be deemed valid based on the length of
                  time the account has been open and general activity on the
                  account. Rewards earned in this scenario may automatically be
                  unlocked and eligible for cash redemption from Brandclub. Such
                  Rewards are determined at Brandclub’s sole discretion.
                  <br />
                  <br />
                  <strong>Sharing the Brandclub App</strong>: A Member may
                  receive a Reward when a new Brandclub user clicks on the
                  Brandclub affiliate link (from text, email, or social channel)
                  and downloads the Brandclub App. Once the new Member has
                  completed its setup and integrated a new retailer into
                  Brandclub, the app-sharing Member may receive a locked Reward.
                  The New Member’s retailer account must be a valid account as
                  determined in Brandclub’s sole discretion. The retailer
                  account will be deemed valid based on the length of time the
                  account has been open and general activity on the account. The
                  Reward may be unlocked for cash redemption when a Member earns
                  another Reward from the same participating Brand.
                  <br />
                  <br />
                  Only Brandclub Members may collect Rewards, and only one
                  Brandclub Member will receive Rewards per qualifying use of
                  the Service or Brandclub Purchase. Brandclub reserves the
                  right to change the methods by which Members may earn Rewards
                  and the way in which Rewards accrue at any time.
                  <br />
                  <br />
                  A Member’s purchases of multiple quantities of the same
                  product will only result in the equivalent of one (1) Reward.
                  <br />
                  <br />
                  Brandclub will add any Rewards you collect to your Member
                  Account after the qualifying use of the Service or Brandclub
                  Purchase. All purchases are deemed verified after the
                  transaction and delivery of the product have been confirmed by
                  Brandclub in its sole discretion. If a Member collects Rewards
                  but we later believe that the Member did not complete a
                  qualifying use of the Service or Brandclub Purchase, or
                  otherwise does not qualify, we reserve the right, in our sole
                  discretion, to remove these Rewards from the Member Account.
                  This could happen if a Member cancels a Brandclub Purchase,
                  which would make the Rewards invalid, or otherwise violates
                  these Terms.
                  <br />
                  <br />
                  Each Member will have a unique balance of locked and unlocked
                  Rewards. This will be visible on the Member Account on the
                  Rewards activity page within the Service. If you are viewing
                  your Rewards on a Brand-specific version of our Service, you
                  will only see your Rewards associated with that Brand. In the
                  Cash Out Rewards section of the Member Account, there will be
                  a condensed summary for every Member that details the Member’s
                  total unlocked Rewards and corresponding value. Selecting Cash
                  Out will allow the Member to redeem the unlocked Rewards and
                  receive up to the full corresponding cash amount (less
                  PayPal/Venmo transaction fee) deposited to the Member’s PayPal
                  or Venmo account. For fraud prevention and security, we only
                  allow Members to redeem Rewards within the Brandclub App or a
                  Brand’s App.
                  <br />
                  <br />
                  All unlocked rewards are eligible to be cashed out through
                  Venmo or PayPal. The user will need to ensure its profile is
                  fully completed and provide the email or phone number
                  associated with their Venmo or PayPal account. The cash
                  rewards will be transferred to the users Venmo or PayPal
                  account within four (4) to six (6) business days. The minimum
                  and maximum amount a member may cash out at one time will be
                  determined at the discretion of Brandclub.
                  <br />
                  <br />
                  Members may not redeem Rewards for cash unless expressly
                  stated. Brandclub reserves the right, in its sole discretion,
                  to change the value of Rewards that have not already been
                  earned and unlocked or to discontinue the Rewards Program at
                  any time.
                  <br />
                  <br />
                  Locked Rewards held in a Member Account will expire after
                  30-60 days from the date the Rewards are added to the Member
                  Account if not converted into Unlocked Rewards. Unlocked
                  Rewards held in a Member Account will expire after 180 days
                  from the date the Rewards become Unlocked Rewards if not
                  redeemed for cash. Any Rewards remaining in a Member Account
                  at the time a Member Account is cancelled by the Member will
                  immediately expire.
                  <br />
                  <br />
                  You can log in to your Member Account to see how many Rewards
                  you have collected at any time, subject to the 180 days
                  expiration period. You are responsible for making sure your
                  Member Account is up to date and accurate. If you believe that
                  you have not collected the correct amount of Rewards, we will
                  look into this for you upon request. If any Rewards become
                  invalid, we will remove such Rewards from your Member Account.
                  <br />
                  <br />
                  <strong>The following will not result in Rewards:</strong>
                  <br />
                  <br />
                  <strong>a</strong>. Any use or purchases made before you
                  joined the Rewards Program or via another Member Account;
                  <br />
                  <strong>b</strong>. Any purchase made after a Rewards
                  promotion has ended; or
                  <br />
                  <strong>c</strong>. If the Member returns the product to the
                  Brand or retailer after the qualifying purchase and receives a
                  refund.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  Updates, changes to, and termination of the rewards program
                </div>
              </div>
              <div className="content">
                <p>
                  <strong>5</strong>. To the maximum extent permitted by
                  applicable law, Brandclub reserves the right to change or
                  cancel this Rewards Program at any time, at its sole
                  discretion, without notice. Without limiting the foregoing,
                  Brandclub may (a) set limitations on Rewards that a Member may
                  earn in connection with the Rewards Program; (b) modify the
                  Service or Brandclub Purchase for which Rewards are available
                  to Members; (c) modify the Reward amounts and redemption rates
                  of the Rewards that are available in connection with the
                  Rewards Program; (d) exclude the Service or Brandclub Purchase
                  from eligibility in the Rewards Program; (e) change the
                  requirements for eligibility in the Rewards Program; and (f)
                  terminate the Rewards Program. Member is solely responsible
                  for verifying that the Rewards Program is still in effect or
                  that the Terms of the Rewards Program are permissible to
                  Member at the time Member redeems any valid Rewards.
                  <br />
                  <br />
                  If Brandclub terminates the Rewards Program, a Member will
                  only be eligible to access Rewards earned and unlocked prior
                  to the date of termination, and all remaining Rewards will
                  become invalid.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Additional disclaimers; limitations</div>
              </div>
              <div className="content">
                <p>
                  <strong>6</strong>. TO THE MAXIMUM EXTENT PERMITTED BY LAW,
                  BRANDCLUB MAKES NO WARRANTIES OF ANY KIND OR NATURE, WHETHER
                  EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY OR
                  FITNESS FOR A PARTICULAR PURPOSE, RESULT, OR THAT
                  PARTICIPATION IN THIS REWARDS PROGRAM WILL RESULT IN
                  ANYPAYMENT, AND EXPRESSLY DISCLAIMS ALL SUCH WARRANTIES.
                  <br />
                  <br />
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW: (A) IN NO EVENT WILL
                  BRANDCLUB BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL,
                  CONSEQUENTIAL, EXEMPLARY, PUNITIVE, OR SPECIAL DAMAGES OF ANY
                  NATURE WHATSOEVER, INCLUDING LOST DATA, LOST PROFITS OR
                  REVENUE, OR FOR ANY CLAIM OR DEMAND BY ANY THIRD PERSON,
                  ARISING OUT OF OR RELATED TO THESE TERMS OR THE PERFORMANCE OR
                  BREACH THEREOF, EVEN IF ADVISED OF THIS POSSIBILITY; AND (B)
                  BRANDCLUB’S AGGREGATE TOTAL LIABILITY TO YOU UNDER THESE TERMS
                  WILL NOT EXCEED THE AMOUNT OF ANY REWARDS ACTUALLY PROVIDED TO
                  YOU UNDER THEM.
                  <br />
                  <br />
                  THE LAWS OF CERTAIN STATES OR OTHER JURISDICTION DO NOT ALLOW
                  LIMITATIONS ON IMPLIED WARRANTIES, OR THE EXCLUSION OR
                  LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY, SOME OR
                  ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MAY
                  NOT APPLY TO YOU, AND YOU MAY HAVE RIGHTS IN ADDITION TO THOSE
                  CONTAINED IN THESE TERMS.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Miscellaneous</div>
              </div>
              <div className="content">
                <p>
                  Any dispute or claim relating in any way to these Rewards
                  Terms will be resolved in accordance with the Terms of
                  Service.
                  <br />
                  <br />
                  You acknowledge and agree that it is a fundamental term and
                  condition precedent of your participation in the Rewards
                  Program that you are not an employee, intermediary or agent of
                  Brandclub, and you will not hold yourself out as, or give any
                  person reason to believe, that you are an employee,
                  intermediary or agent of Brandclub. You agree nothing in your
                  participation will be construed as establishing an employment
                  or agency relationship between Brandclub and you. Accordingly,
                  you have not at any time been and are not entitled to, and
                  hereby irrevocably waive any right or claim to, the benefits
                  provided by Brandclub to its employees from time to time,
                  including vacation time, benefits, salary, bonus, stock or
                  stock options, profit sharing, insurance, or medical and
                  health benefits.
                  <br />
                  <br />
                  In the event of a conflict between these Rewards Terms and the
                  Brandclub Terms of Service, these Rewards Terms will prevail
                  with respect to the Rewards Program.
                  <br />
                  <br />
                  If you have any questions regarding the Rewards Program or
                  these Rewards Terms, please email us at{" "}
                  <a href="mailto:support@brandclub.com">
                    support@brandclub.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const RewardTerms = () => {
  const ref = useRef(undefined) as any;
  const disable = false;
  if (disable) {
    return <></>;
  }
  return (
    <div className="site" style={{ height: "unset" }} ref={ref}>
      <Helmet>
        <title>Reward Terms</title>
        <meta
          name="description"
          content="Learn more about our key terms and policies regarding rewards."
        />
      </Helmet>
      <RewardTermsHeader />
      <RewardTermsContent />
    </div>
  );
};
export default RewardTerms;
